import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../globals'
import { IepService } from "../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../Models/IIepInstance'
import { Message, SelectItem } from 'primeng/primeng';
import { IChildFindFollowupTable } from '../../../Models/IChildFindFollowupTable';
import { IChildFindKnownAnswers } from '../../../Models/IChildFindKnownAnswers';
import { ChildFindFollowupService } from '../../../Services/ChildFindFollowupService';
import { IChildFindFollowup } from "../../../Models/IChildFindFollowup";
import { ILookupBase } from '../../../Models/ILookupBase';
import { LookupService } from 'src/app/Services/LookupService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { Observable, throwError, of } from "rxjs";
import { IStudentEnrollment } from '../../../Models/IStudentEnrollment'
import { StudentService } from '../../../Services/StudentService'
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'ChildFindFollowup',
  templateUrl: './ChildFindFollowup.component.html',
  styleUrls: ['./ChildFindFollowup.component.css']
})

export class ChildFindFollowupComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  messages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  canEditChildFind: boolean;
  childFindView: boolean;
  saveClicked: boolean;
  showSpinner: boolean = false;
  validation: boolean;
  oneYearPast: Date;
  childFindFollowupTable: IChildFindFollowupTable[] = [];
  childFindKnownAnswers: IChildFindKnownAnswers;
  childFindFollowupDB: any = [];
  _lookupService: LookupService;
  _lookupTypeEnum: LookupTypeEnum;
  _studentService: StudentService;
  lookupDisabilityList: ILookupBase[];
  reportParamArray: IReportParameter[];
  selectedDisabilityCodes: any[];

  mostRecentContiguousEnrollmentStartDate: Date;
  isAdminPlacementNeeded: SelectItem;//dropdown
  _isAdminPlacementNeeded: string = null;
  isAdminPlacementNeededList: ILookupBase[];
  contiguousStudentEnrollments: IStudentEnrollment[];
  enableAdminPlacementNeeded: boolean = false;
  canAnswerQuesion18: boolean = false;

  constructor
    (
      private globals: Globals,
      reportService: ReportService,
      private _childFindFollowupService: ChildFindFollowupService,
      iepService: IepService,
      lookupService: LookupService,
      studentService: StudentService,
      @Inject('BASE_URL') baseUrl: string) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
    this._studentService = studentService;
  }

  ngOnInit(): void {
    if (this._myGlobals.selectedStudent.localStudentId != null) {
      this.GetChildFindFollowups();
    }

    switch (this._myGlobals.spedSecurityUser.roleName) {
      case "Provider":
      case "SELPA":
      case "SiteAdministrator":
      case "SysAdmin":
        this.canAnswerQuesion18 = true;
        break;
    }
  }

  GetChildFindFollowups(): void {
    this.showSpinner = true;
    this.mostRecentContiguousEnrollmentStartDate = null;
    this._studentService.getContiguousStudentEnrollments(this._myGlobals.selectedStudent.localStudentId)
      .subscribe((res: IStudentEnrollment[]) => {
        for (let item of res) {
          if (this.mostRecentContiguousEnrollmentStartDate == null || this.mostRecentContiguousEnrollmentStartDate < item.startDate) {
            this.mostRecentContiguousEnrollmentStartDate = item.startDate;
          }
        }
        this._childFindFollowupService.getAllChildFindFollowup(this._myGlobals.selectedStudent.localStudentId).subscribe((res: IChildFindFollowup[]) => {
          this.childFindFollowupTable = [] as IChildFindFollowupTable[];
          for (let item of res) {
            //can only create new form if child is in "P" SPED status
            if (this._myGlobals.selectedStudent.spedStatus == "P"
              && item.id == null
              && item.isAdministrativePlacementNeeded == null
              && item.contiguousEnrollmentStartDate == this.mostRecentContiguousEnrollmentStartDate) {
              this.childFindFollowupTable.push({ StartDate: new Date(this.mostRecentContiguousEnrollmentStartDate), Id: 0, Action: "Create ChildFind" });
            }
            else if (this._myGlobals.selectedStudent.spedStatus == "P"
              && item.id > 0
              && item.isAdministrativePlacementNeeded == null
              && item.contiguousEnrollmentStartDate == this.mostRecentContiguousEnrollmentStartDate) {
              this.childFindFollowupTable.push({ StartDate: new Date(item.contiguousEnrollmentStartDate), Id: item.id, Action: "Edit ChildFind" });
            }
            else if (item.id == null) {
              this.childFindFollowupTable.push({ StartDate: new Date(item.contiguousEnrollmentStartDate), Id: item.id, Action: "No ChildFind" });
            }
            else {
              this.childFindFollowupTable.push({ StartDate: new Date(item.contiguousEnrollmentStartDate), Id: item.id, Action: "View ChildFind" });
            }
          }
          this.showSpinner = false;
        },
          err => {
            this.errorHandler(err);
            this.showSpinner = false;
          }
        );
      },
        err => {
          this.errorHandler(err);
        }
      )
  }

  GetChildFindFollowup(selectedId) {
    this._childFindFollowupService.getChildFindFollowup(selectedId)
      .subscribe((res: IChildFindFollowup) => {
        this.childFindFollowupDB = res;
        if (this.childFindFollowupDB.contiguousEnrollmentStartDate != null) {
          this.childFindFollowupDB.contiguousEnrollmentStartDate = new Date(this.childFindFollowupDB.contiguousEnrollmentStartDate);
        }
        if (this.childFindFollowupDB.furtherActionId != null) {
          this.childFindFollowupDB.furtherActionId = this.childFindFollowupDB.furtherActionId.toString();
        }
        if (this.childFindFollowupDB.sraAdditionalRequestDate != null) {
          this.childFindFollowupDB.sraAdditionalRequestDate = new Date(this.childFindFollowupDB.sraAdditionalRequestDate);
        }
        if (this.childFindFollowupDB.sraEmailDate != null) {
          this.childFindFollowupDB.sraEmailDate = new Date(this.childFindFollowupDB.sraEmailDate);
        }
        if (this.childFindFollowupDB.parentContactedIepDate != null) {
          this.childFindFollowupDB.parentContactedIepDate = new Date(this.childFindFollowupDB.parentContactedIepDate);
        }
        if (this.childFindFollowupDB.parentContectedAdditionalInfoDate != null) {
          this.childFindFollowupDB.parentContectedAdditionalInfoDate = new Date(this.childFindFollowupDB.parentContectedAdditionalInfoDate);
        }
        this.selectedDisabilityCodes = (this.childFindFollowupDB.disabilityCodeCSV == null || this.childFindFollowupDB.disabilityCodeCSV == "") ? null : this.childFindFollowupDB.disabilityCodeCSV.toString().split(",");
        this.LoadLookupValues();
        this.scrollToBottom()
        this.childFindView = true;
        this.adminPlacementNeeded();
        let today = new Date();
        this.oneYearPast = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate() + 1);
      },
        err => this.errorHandler(err)
      );
  }


  EditChildFindFollowup(selectedId) {
    this.canEditChildFind = true;
    this.clearMessages();
    this.saveClicked = false;
    this.GetChildFindFollowup(selectedId)
  }

  AddChildFindFollowup() {
    this.canEditChildFind = true;
    this.clearMessages();
    this.saveClicked = false;
    //get default Answers
    this._childFindFollowupService.getChildFindKnownAnswers(this._myGlobals.selectedStudent.localStudentId)
      .subscribe((res: IChildFindKnownAnswers) => {
        this.childFindKnownAnswers = res;
        this.childFindFollowupDB = {} as IChildFindFollowup;
        this.childFindFollowupDB.localStudentId = this._myGlobals.selectedStudent.localStudentId;
        this.childFindFollowupDB.id = 0;
        this.childFindFollowupDB.contiguousEnrollmentStartDate = new Date(this.mostRecentContiguousEnrollmentStartDate);
        this.childFindFollowupDB.isPossibleSped = this.childFindKnownAnswers.possibleSPED;
        this.childFindFollowupDB.isSelfIdentified = this.childFindKnownAnswers.isSelfIdentify;
        this.childFindFollowupDB.hasLacoeIep = this.childFindKnownAnswers.isLacoeIEP;
        this.childFindFollowupDB.hasSraDistrictRequest = this.childFindKnownAnswers.isSraDistrictRequest;
        if (this.childFindKnownAnswers.sraDistrictRequestDate != null) {
          this.childFindFollowupDB.sraAdditionalRequestDate = new Date(this.childFindKnownAnswers.sraDistrictRequestDate);
        }
        this.LoadLookupValues();
        this.scrollToBottom()
        this.childFindView = true;
      },
        err => this.errorHandler(err)
      );
  }

  //Save the ChildFindFollowup
  saveChildFindFollowup() {
    this.clearMessages();
    this.validateForm();
    this.canEditChildFind = false;
    if (this.validation == true) {
      //clear the values
      this.clearvalues();
      this.childFindFollowupDB.disabilityCodeCSV = this.selectedDisabilityCodes?.toString();
      this.saveClicked = true;
      //update values
      this._childFindFollowupService.insertUpdateChildFindFollowup(this.childFindFollowupDB)
        .subscribe((res: IChildFindFollowup) => {
          let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
          this.addMessage(successMessage);
          this.saveClicked = false
          this.childFindView = false;
          this.GetChildFindFollowups();
        },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
            this.saveClicked = false;
          }
        )
    }
    else {
      //validation has failed; allow user to continue to edit so that they can fix validation errors
      this.canEditChildFind = true;
      this.saveClicked = false;
    }
  }

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.Disability]).subscribe((res: ILookupBase[]) => {
      this.lookupDisabilityList = res.map(o => {
        return {
          value: o.value,
          label: o.value + " " + o.label,
          shortText: null,
          updatedOn: null
        };
      });

      this.lookupDisabilityList = this.lookupDisabilityList.slice(0, 11);

    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.FurtherAction])
      .subscribe((res: ILookupBase[]) => {
        this.isAdminPlacementNeededList = [] as ILookupBase[];
        this.isAdminPlacementNeededList.push({ label: '-- Select option --', value: null, shortText: 'Select option', updatedOn: null });
        this.isAdminPlacementNeededList.push.apply(this.isAdminPlacementNeededList, res);
      },
        err => console.error(err)
      )
  }

  clearvalues() {
    if (this.childFindFollowupDB.hasCalpadsDisabilityCode != 'Y' && this.selectedDisabilityCodes != null) {
      this.selectedDisabilityCodes = null
    }
    if (this.childFindFollowupDB.hasCalpadsNps != 'Y' && this.childFindFollowupDB.npsName != null) {
      this.childFindFollowupDB.npsName == null
    }
    if (this.childFindFollowupDB.isSraEmailSent != 'Y' && this.childFindFollowupDB.sraEmailDate != null) {
      this.childFindFollowupDB.sraEmailDate == null
    }
    if (this.childFindFollowupDB.isParentContactedIep != 'Y' && this.childFindFollowupDB.parentContactedIepDate != null) {
      this.childFindFollowupDB.parentContactedIepDate == null
    }
    if (this.childFindFollowupDB.isParentcontactedAdditionalInfo != 'Y' && this.childFindFollowupDB.parentContectedAdditionalInfoDate != null) {
      this.childFindFollowupDB.parentContectedAdditionalInfoDate == null
    }
  }

  validateForm() {
    this.validation = true;
    if (this.childFindFollowupDB.hasCalpadsDisabilityCode == 'Y' && this.selectedDisabilityCodes == null) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Questions 11 Disability code is missing'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.childFindFollowupDB.hasCalpadsNps == 'Y' && (this.childFindFollowupDB.npsName == null || this.childFindFollowupDB.npsName == '')) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Questions 12 Text is missing'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.childFindFollowupDB.isSraEmailSent == 'Y' && (this.childFindFollowupDB.sraEmailDate == null || this.childFindFollowupDB.sraEmailDate == '')) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Questions 15 Date is missing'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.childFindFollowupDB.isParentContactedIep == 'Y' && (this.childFindFollowupDB.parentContactedIepDate == null || this.childFindFollowupDB.parentContactedIepDate == '')) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Questions 16 Date is missing'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.childFindFollowupDB.isParentcontactedAdditionalInfo == 'Y' && (this.childFindFollowupDB.parentContectedAdditionalInfoDate == null || this.childFindFollowupDB.parentContectedAdditionalInfoDate == '')) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Questions 17 Date is missing'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.canAnswerQuesion18 && this.childFindFollowupDB.isAdministrativePlacementNeeded?.length == 1 && this.childFindFollowupDB.furtherActionId == null ) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Questions 18 requires selecting Yes/NO and selecting a valid item from the drop down list.'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
  }

  adminPlacementNeeded(): void {
    this.enableAdminPlacementNeeded = false;
    if (this.childFindFollowupDB.isLacoeIepSigned != null
      && this.childFindFollowupDB.hasDistrictIep != null
      && this.childFindFollowupDB.isDistrictIepSigned != null
      && this.childFindFollowupDB.hasExistingPar != null
      && this.childFindFollowupDB.hasExitIep != null
      && this.childFindFollowupDB.hasRevoked != null
      && this.childFindFollowupDB.hasCalpadsSpedCode != null
      && this.childFindFollowupDB.hasCalpadsDisabilityCode != null
      && this.childFindFollowupDB.hasCalpadsNps != null
      && this.childFindFollowupDB.isSraAdditionalRecordsNeeded != null
      && this.childFindFollowupDB.isSraEmailSent != null
      && this.childFindFollowupDB.isParentContactedIep != null
      && this.childFindFollowupDB.isParentcontactedAdditionalInfo != null
      && this.canEditChildFind == true) {
      this.enableAdminPlacementNeeded = true;
    }

  }

  question18Selected(): void {

    switch (this.childFindFollowupDB.isAdministrativePlacementNeeded) {
      case 'Y':
        this.childFindFollowupDB.furtherActionId = '2';
        break;
      default:
        this.childFindFollowupDB.furtherActionId = null;
        break;
    }

  }

  closeQuestions(): void {
    this.childFindView = false;
  }

  addMessage(msg: Message) {
    if (!this.messages)
      this.messages = [];
    this.messages = [...this.messages, msg];
  }

  clearMessages() {
    this.messages = [];
  }

  cancel() {
    this.clearMessages();
    this.canEditChildFind = false;
    this.childFindView = false;
  }

  scrollToBottom(): void {
    let pos = window.pageYOffset;
    //Scroll the from to position horizontally 0 and vertically 500
    if (pos < 500) {
      window.scrollTo(0, 500);
    }
  }

  errorHandler(error: Response): Observable<any> {
    console.log(error);
    return Observable.throw(error);
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'ChildFindFollowUpId', parameterValue: this.childFindFollowupDB.id.toString() }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon("ChildFindFollowUp", this.reportParamArray);
  }

}
